"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-12-24 15:01:27
 * @LastEditTime: 2022-02-22 10:50:21
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\constant\chart\x-axis.ts
 */
exports.default = {
    default: {
        type: "category",
        // boundaryGap: false,
        axisLine: {
            show: true,
            lineStyle: {
                color: "#E0E7FF"
            }
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            color: "#748592",
            fontSize: "12px",
            margin: 10,
            align: "center"
        },
        splitLine: {
            show: true,
            lineStyle: {
                type: "dashed",
                color: ["rgba(235, 236, 238, 0.75)"]
            }
        }
    },
    normal: {
        type: "category",
        axisLine: {
            show: true,
            lineStyle: {
                color: "#E5E6EB"
            }
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            color: "#86909C",
            fontSize: "12px",
            margin: 10,
            align: "center"
        },
        splitLine: {
            show: false,
            lineStyle: {
                color: "#F2F3F5 "
            }
        }
    }
};
//# sourceMappingURL=x-axis.js.map